import type { JSX } from 'react';
import { LegalPage } from './LegalPage';

export function Terms(): JSX.Element {
  return <LegalPage slug="terms" />;
}

export default Terms;
